import client from '../client'

export const getSuggestionsKey = `${process.env.NEXT_PUBLIC_SEARCH_DOMAIN}/api/Search/GetSuggestions`

export async function getSuggestions({ term }) {
  const params = new URLSearchParams({ term })

  return client(`${getSuggestionsKey}?${params.toString()}`).then((res) => res.suggestions)
}
